module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/yes.56baf66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/yes.jpg
// module id = vj2B
// module chunks = 0